import { CenterContainer } from './styles';

export default CenterContainer;
